// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1ArSp","content":"LoadingAlert_content__M1exh"};